import type { ProfilZiel } from '../types';
import { globalNav, oeffneMailVonAussen, oeffneKlassenAktionen } from './nav';

// Welle U2: Insight-Typ → Ziel-Tab im Schülerprofil (eine Stelle für Heute und Tasks)
export const PROFIL_ZIEL: Record<string, ProfilZiel> = {
  fehlzeit_rot: 'fehlzeiten', fehlzeit_gelb: 'fehlzeiten',
  offener_punkt: 'ueberblick', gespraech_followup: 'gespraeche',
};

// Radar-Insight-IDs aus /api/dashboard/insights (server/routes/dashboard.js) → Insight-Typ
const ID_TYP: [string, string][] = [
  ['fz_rot', 'fehlzeit_rot'], ['fz_gelb', 'fehlzeit_gelb'], ['offener_punkt', 'offener_punkt'],
  ['aktion', 'aktion_faellig'], ['mail_prio', 'mail_prio_kontakt'], ['mail', 'mail_unbeantwortet'],
  ['gespraeche_fu', 'gespraech_followup'],
];

type TaskQuelle = {
  quelle: string; quelle_ref_id: string | null;
  schueler_id: number | null; klasse_id: number | null;
};

// Welle U6b: "Zur Quelle" einer Aufgabe — Mail über oeffneMailVonAussen, Radar-Insight
// über dasselbe Ziel wie in Heute (U2). Liefert null, wenn die Quelle nicht auflösbar ist.
export function taskQuelleZiel(task: TaskQuelle, setOpenProfilId: (id: number | null, ziel?: ProfilZiel) => void): (() => void) | null {
  const ref = task.quelle_ref_id ?? '';
  if (task.quelle === 'mail' && /^\d+$/.test(ref)) return () => oeffneMailVonAussen(Number(ref));
  // P1a: Nachfassen aus einem Gespräch → Gespräche im Schülerprofil
  if (task.quelle === 'gespraech' && task.schueler_id) { const sid = task.schueler_id; return () => { setOpenProfilId(sid, 'gespraeche'); globalNav('schueler'); }; }
  if (task.quelle !== 'radar') return null;
  const treffer = ID_TYP.find(([praefix]) => new RegExp(`^${praefix}_(\\d+)$`).test(ref));
  if (!treffer) return null;
  const nr = Number(ref.slice(treffer[0].length + 1));
  const typ = treffer[1];
  const profil = (sid: number) => () => { setOpenProfilId(sid, PROFIL_ZIEL[typ]); globalNav('schueler'); };
  switch (typ) {
    case 'fehlzeit_rot': case 'fehlzeit_gelb': return profil(nr);   // ID trägt die Schüler-ID
    case 'offener_punkt': case 'gespraech_followup':
      return task.schueler_id ? profil(task.schueler_id) : () => globalNav('klasse');
    case 'aktion_faellig': return () => oeffneKlassenAktionen(task.klasse_id ?? null, nr);
    case 'mail_prio_kontakt': case 'mail_unbeantwortet': return () => oeffneMailVonAussen(nr);
    default: return null;
  }
}
